






























































































































































































































































































































































































































































































































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AccountModule from '@/store/modules/Account';
import GeneralModule from '@/store/modules/General';
import BalanceModule from '@/store/modules/Balance';
import AuthModule from '@/store/modules/Auth';
import CurrencyModule from '@/store/modules/Currency';
import MarketingModule from '@/store/modules/Marketing';
import ProfileModule from '@/store/modules/Profile';
import CreateAccountData from '@/data/CreateAccount';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import jwt_decode from 'jwt-decode';
import Password from 'vue-password-strength-meter';
import generatePassword from 'omgopass';

@Component({
  components: {
    Password,
  },
})
export default class AddAgentView extends Mixins(ErrorHandleMixin) {
  AccountInstance = getModule(AccountModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  AuthInstance = getModule(AuthModule, this.$store);

  BalanceInstance = getModule(BalanceModule, this.$store);

  CurrencyInstance = getModule(CurrencyModule, this.$store);

  MarketingInstance = getModule(MarketingModule, this.$store);

  ProfileInstance = getModule(ProfileModule, this.$store);

  mainKey = 0;

  api = 'API';

  currencyType = 'currency';

  ipWhitelist = '';

  valuePt = 0;

  valuePtDecimal = 0;

  UserData: any = { ...CreateAccountData.initialUserData() };

  isCheckedPrefix = false;

  isMechanic = false;

  isMechanicPermission = false;

  currencyRate: any = [];

  isCurrencyType = false;

  currency = [];

  crypto = [];

  isCurrency = false;

  passwordDetail: any = {};

  isCreateAccountModal = false;

  createdAccount = {
    prefix: '',
    loginName: '',
    password: '',
    currency: '',
  };

  showCreatedPassword = false;

  copyCreatedAccount() {
    const text = `Prefix : ${this.createdAccount.prefix}
Login name : ${this.createdAccount.loginName}
Password : ${this.createdAccount.password}
Currency : ${this.createdAccount.currency}`;

    navigator.clipboard.writeText(text);

    this.GeneralInstance.ShowAlert({
      isAlert: true,
      alertMsg: this.$t('createAccount.agentCredentialsCopied'),
      alertColor: 'success',
    });

    const fallbackCopy = () => {
      const el = document.createElement('textarea');
      el.value = text;
      el.setAttribute('readonly', '');
      el.style.position = 'fixed';
      el.style.opacity = '0';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
    };

    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(text).catch(() => fallbackCopy());
    } else {
      fallbackCopy();
    }
  }

  async created() {
    const resSelf = await this.MarketingInstance.Fetch();
    this.UserData.isFeature = await resSelf[0].isFeature;
    this.isMechanic = this.AuthInstance.user.userPermission.reportMechanic === 'edit'
      && this.AuthInstance.user.role === 'AGENT';
    this.isMechanicPermission = this.AuthInstance.user.userPermission.reportMechanic === 'edit';
    const { currency, crypto } = await this.CurrencyInstance.fetchCurrencyRate({
      data: { currency: '' },
    });
    this.currency = currency;
    this.crypto = crypto;
    this.initial();
  }

  handleChange(currency) {
    if (currency !== '') {
      this.UserData.currency = currency;
    }
  }

  async initial() {
    this.UserData.role = 'AGENT';
    if (!this.UserData) this.UserData = {} as any;
    if (!('currency' in this.UserData)) {
      if (this.$set) this.$set(this.UserData, 'currency', null);
      else (this.UserData as any).currency = null;
    }
    if (['COMPANY', 'SUBCOMPANY'].includes(this.AuthInstance?.user?.role)) {
      this.UserData.type = 'CREDITLINE';
      this.api = 'B2B';
      this.currencyRate = Array.isArray(this.currency)
        ? this.currency
        : typeof this.currency === 'string' && this.currency
          ? [this.currency]
          : [];
      this.currencyType = 'currency';
    } else {
      const expToken: any = jwt_decode(this.AuthInstance?.token ?? '');
      const raw = typeof expToken?.currency === 'string' ? expToken.currency.trim() : '';
      this.currencyRate = raw ? [raw] : [];
      const agentCurrency = this.currencyRate[0] || 'USD';
      if (this.$set) this.$set(this.UserData, 'currency', agentCurrency);
      else this.UserData.currency = agentCurrency;
      this.isCurrency = true;
      const cryptoList: string[] = Array.isArray(this.crypto)
        ? this.crypto.map((c: any) => String(c).toUpperCase())
        : typeof this.crypto === 'string'
          ? (this.crypto as string)
            .split(',')
            .map((s: string) => s.trim().toUpperCase())
            .filter(Boolean)
          : [];
      if (agentCurrency !== 'USD' && cryptoList.includes(agentCurrency)) {
        this.currencyRate = cryptoList;
        this.isCurrency = false;
      }
    }
    const { status, data } = await this.AccountInstance.GenerateUser({
      role: this.UserData.role,
    });
    if (status?.code) {
      this.checkError(status);
    } else if (data?.username) {
      if (this.$set) this.$set(this.UserData, 'username', data.username);
      else this.UserData.username = data.username;
    }
  }

  toggleAPI({ target: { innerText } }) {
    this.api = innerText;
    if (['COMPANY', 'SUBCOMPANY'].includes(this.AuthInstance.user.role)) {
      this.UserData.type = 'CREDITLINE';
    } else {
      this.UserData.type = 'SEAMLESS';
    }
  }

  toggleBetType({ target: { innerText } }) {
    this.UserData.type = innerText.trim().toUpperCase().replace(' ', '');
  }

  toggleCurrencyType(value) {
    this.currencyType = value;
    this.isCurrencyType = !this.isCurrencyType;
    this.currencyRate = this.crypto;
    this.UserData.isCrypto = this.isCurrencyType;
    if (value === 'currency') this.currencyRate = this.currency;
    this.UserData.currency = '';
  }

  isAbleToSubmit(invalid: boolean): boolean {
    return !(
      !invalid
      && ['CREDITLINE', 'SEAMLESS', 'TRANSFER'].includes(this.UserData.type)
    );
  }

  injectAlertZIndexStyle() {
    if (document.getElementById('add-agent-alert-style')) return;

    const style = document.createElement('style');
    style.id = 'add-agent-alert-style';
    style.innerHTML = `
    .ams-alert-top {
      z-index: 999999 !important;
    }
  `;
    document.head.appendChild(style);
  }

  removeAlertZIndexStyle() {
    const style = document.getElementById('add-agent-alert-style');
    if (style) style.remove();
  }

  @Watch('isCreateAccountModal')
  onCreateAccountModalChanged(val: boolean) {
    if (val) this.injectAlertZIndexStyle();
    else this.removeAlertZIndexStyle();
  }

  beforeDestroy() {
    this.removeAlertZIndexStyle();
  }

  async onSubmit() {
    const plainPassword = this.UserData.password;

    if (this.ipWhitelist) {
      this.UserData.ipWhitelist = this.ipWhitelist.split(',');
    }
    this.UserData.isMechanic = this.isMechanic;
    this.UserData.userPermission.reportMechanic = this.isMechanic
      ? 'edit'
      : 'off';
    this.GeneralInstance.toggleLoading(true);
    this.UserData.pt.general = Number(this.valuePt + this.valuePtDecimal) / 100;

    const {
      status: { code, message },
      data,
    } = await this.AccountInstance.CreateAccount(this.UserData);

    if (code === 0) {
      await this.BalanceInstance.Refill({
        userId: data._id,
        type: 'TRANSFER',
        amount: this.UserData.balance,
        username: data.username,
        currency: this.UserData.currency,
        source: this.UserData.source,
      });

      this.createdAccount = {
        prefix: this.UserData.source,
        loginName: data.username,
        password: plainPassword,
        currency: this.UserData.currency,
      };

      this.mainKey += 1;
      this.UserData = { ...CreateAccountData.initialUserData() };
      this.initial();
      this.ipWhitelist = '';
    }

    await this.ProfileInstance.GetBalance();

    this.GeneralInstance.toggleLoading(false);

    this.GeneralInstance.ShowAlert({
      isAlert: true,
      alertMsg: message,
      alertColor: code === 0 ? 'success' : 'danger',
    });

    this.UserData = { ...CreateAccountData.initialUserData() };
    this.initial();
    this.valuePt = 0;
    this.valuePtDecimal = 0;

    if (code === 0) {
      this.injectAlertZIndexStyle();
      this.showCreatedPassword = false;
      this.isCreateAccountModal = true;
      this.copyCreatedAccount();
    }
  }

  async checkPrefix() {
    if (!this.UserData.source) {
      this.GeneralInstance.ShowAlert({
        isAlert: true,
        alertMsg: 'Prefix Required',
        alertColor: 'danger',
      });
    } else {
      this.GeneralInstance.toggleLoading(true);
      const { code, message } = await this.AccountInstance.CheckPrefix({
        prefix: this.UserData.source,
      });
      this.GeneralInstance.toggleLoading(false);
      this.isCheckedPrefix = code === 0;
      this.isMechanicPermission = this.AuthInstance.user.userPermission.reportMechanic === 'edit';
      this.GeneralInstance.ShowAlert({
        isAlert: true,
        alertMsg: message,
        alertColor: code === 0 ? 'success' : 'danger',
      });
    }
  }

  @Watch('UserData.source')
  changePrefix() {
    this.isCheckedPrefix = false;
  }

  showFeedback(detail) {
    this.passwordDetail = detail;
  }

  async genPass() {
    const password = await generatePassword();
    this.UserData.password = password;
    this.UserData.confirmPassword = password;
    navigator.clipboard.writeText(password);
    this.GeneralInstance.ShowAlert({
      isAlert: true,
      alertMsg: 'Your generated password was copy to clipboard.',
      alertColor: 'success',
    });
  }
}
